import React, { useState, useEffect, useRef } from 'react';
import styled from "styled-components";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useText } from "locales/useGetText";

const MultiSelectDropdownCheckbox = ({ options, selectedStates, setSelectedStates, onChartFilterChange }) => {  
  const locale = useText("commonModals");
  const [displayStatesList, setDisplayStatesList] = useState(false);
  const [stateAllChecked, setStateAllChecked] = useState(true); // Set default to true
  const [stateSearch, setStateSearch] = useState('');
  const dropdownRef = useRef(null);

  // Update "All" checkbox state based on selectedStates
  useEffect(() => {
    if (selectedStates?.length === options?.length) {
      setStateAllChecked(true);
    } else {
      setStateAllChecked(false);
    }
  }, [selectedStates, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDisplayStatesList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredOptions = options?.filter(option =>
    option.label.toLowerCase().includes(stateSearch.toLowerCase()) ||
    option.city.toLowerCase().includes(stateSearch.toLowerCase()) ||
    option.state.toLowerCase().includes(stateSearch.toLowerCase())
  );

  const onCheckStateBox = (value, checked) => {
    if (value === 'ALL') {
      setStateAllChecked(checked);
      if (checked) {
        setSelectedStates(options.map(option => option.value));
      } else {
        setSelectedStates([]);
      }
    } else {
      setSelectedStates(prevSelectedStates => {
        if (checked) {
          // Add the value to selectedStates
          return [...prevSelectedStates, value];
        } else {
          // Remove the value from selectedStates
          return prevSelectedStates.filter(state => state !== value);
        }
      });
    }
    // Trigger the API call in the parent component
    onChartFilterChange();
  };

  return (
    <LocationPrefWrapper ref={dropdownRef}>
      <DropdownToggle onClick={() => setDisplayStatesList(!displayStatesList)}>
        {locale("selectLocation")}
        <ExpandMoreIcon style={{ color: "inherit" }} />
      </DropdownToggle>
      {displayStatesList && (
        <StatesListDiv className="statesListDiv">
          <div className="searchContainer">
            <input 
              type="text" 
              placeholder="Search..." 
              value={stateSearch} 
              onChange={(e) => setStateSearch(e.target.value)} 
            />
          </div>
          <div className="statesListInnerDiv">
            <label className='checkbox-container' style={{ margin: '10px' }}>
              <input
                id={'ALL'}
                name={'ALL'}
                type='checkbox'
                checked={stateAllChecked}
                disabled={false}
                onClick={(event) => {
                  onCheckStateBox('ALL', event.target.checked)
                }}
              />
              <span className='checkMark'></span>
              All
            </label>
            {filteredOptions?.map(item => (
              <label className='checkbox-container' style={{ margin: '10px' }}>
                <input
                  id={item.label}
                  name={item.label}
                  type='checkbox'
                  checked={selectedStates.includes(item.value)}
                  disabled={false}
                  onClick={(event) => {
                    onCheckStateBox(item.value, event.target.checked)
                  }}
                />
                <span className='checkMark'></span>
                {`${item.label}, ${item.city}, ${item.state}`}
              </label>
            ))}
          </div>
        </StatesListDiv>
      )}
    </LocationPrefWrapper>
  );
};

export default MultiSelectDropdownCheckbox;


const LocationPrefWrapper = styled.div`
  margin: 10px 0 10px 0;
  position: relative;
  button{
    background: transparent;
    width: 220px;
    height: 37px;
  }
`;

const DropdownToggle = styled.button`
  height: 37px;
  border-radius: 5px;
  border: solid 1px #e0e0e0;
  width: 200px;
  padding: 7px;
  cursor: pointer;
  font-size: 13px;
  .MuiSvgIcon-root{
    float: right;
    font-size: 1.3rem;
  }
`;

const StatesListDiv = styled.div`
  position: absolute;
  top: 37px; /* Adjust as per your design */
  left: 0;
  background-color: white;
  z-index: 1000; /* Set a high value to ensure it's above other content */
  border: 1px solid #87cdf1;
  border-radius: 5px;
  width: 100%;
  max-height: 320px;
  overflow-y: auto;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  .searchContainer {
    margin-bottom: 10px;
  }

  .searchContainer input {
    width: calc(100% - 10px);
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 12px;
  }
  .searchContainer input[type=text]:focus {
    border: 1px solid #e0e0e0;
  }

  /* The container */
  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 24px;
    margin-bottom: 0;
    cursor: pointer;
    font-size: 11px !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: "latoregular" !important;
    letter-spacing: 0.23px !important;
    color: inherit;
  }
  
  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  /* Create a custom checkbox */
  .checkMark {
    position: absolute;
    top: 0;
    left: 0;
    background-color: transparent;
    border-radius: 2px;
    border: solid 2px #61ae24;
    height: 18px;
    width: 18px;
  }
  
  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkMark {
    background-color: transparent;
  }
  
  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkMark {
        background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
  }
  /* Create the checkMark/indicator (hidden when not checked) */
.checkMark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkMark when checked */
.checkbox-container input:checked ~ .checkMark:after {
  display: block;
}

/* Style the checkMark/indicator */
.checkbox-container .checkMark:after {
  left: 4px;
  top: 0px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
`;  
